<script setup>
import { onMounted, computed, defineProps } from 'vue';
import { useStore } from 'vuex'
import Swal from 'sweetalert2';
import axios from 'axios';
import { authHeader } from '@/helpers/authservice/auth-header';
import "@vueform/multiselect/themes/default.css";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

onMounted(()=>{
  getRejectReasonList();
});

const store = useStore()

const props = defineProps({
  phase_id: {
    type: Number,
    required: true
  }
});

const selected_violation = computed(() => store.state.trafficRecordComponent.selected_violation);
const traffic_record = computed(() => store.state.trafficRecordComponent.traffic_record);
const reject_reason_list = computed(() => store.state.trafficRecordComponent.reject_reason_list);

const selected_registration_type = computed(() => store.state.trafficRecordComponent.selected_registration_type);
const selected_lane = computed(() => store.state.trafficRecordComponent.selected_lane);
const selected_motor_vehicle_type = computed(() => store.state.trafficRecordComponent.selected_motor_vehicle_type);
const input_remarks = computed(() => store.state.trafficRecordComponent.input_remarks);
const mv_file_record = computed(() => store.state.trafficRecordComponent.mv_file_record);
const input_registration_number = computed(() => store.state.trafficRecordComponent.input_registration_number);
const input_speed_limit = computed(() => store.state.trafficRecordComponent.input_speed_limit);

const selected_reject_reason = computed({
  get:() => store.state.trafficRecordComponent.selected_reject_reason,
  set:(val) => store.commit('trafficRecordComponent/SET_SELECTED_REJECT_REASON',val)
});
const other_reject_reason = computed({
  get:() => store.state.trafficRecordComponent.other_reject_reason,
  set:(val) => store.commit('trafficRecordComponent/SET_OTHER_REJECT_REASON',val)
});

const getRejectReasonList = () => store.dispatch('trafficRecordComponent/getRejectReasonList');

const selectRejectReason = () => {
  other_reject_reason.value = '';
}

const reject = async () => {
  if(!selected_reject_reason.value){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please select a reject reason.',
    })
  }

  if(selected_reject_reason.value && selected_reject_reason.value == 7 && !other_reject_reason.value){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please enter other reason.',
    })
  }

  const confirm = await Swal.fire({
    icon: 'warning',
    title: 'Continue?',
    text: 'Do you want to proceed in rejecting this record?',
    showCancelButton: true,
    confirmButtonText: 'Proceed',
  })
  if (!confirm.isConfirmed) {
    return;
  }
  try{
    let inputs = {
      phase_id: traffic_record.value.phase_id,
      reject_reason_id: selected_reject_reason.value,
      violation_penalty_id: selected_violation.value
    };

    if(selected_reject_reason.value && selected_reject_reason.value == 7 && other_reject_reason.value){
      inputs.other_reject_reason = other_reject_reason.value
    }

    if(selected_lane.value){
      inputs.lane = selected_lane.value
    }

    if(input_speed_limit.value){
      inputs.speed_limit = input_speed_limit.value
    }

    if(selected_registration_type.value){
      inputs.registration_type_id = selected_registration_type.value
    }

    if(selected_motor_vehicle_type.value){
      inputs.motor_vehicle_type_id = selected_motor_vehicle_type.value
    }
    
    if(input_registration_number.value){
      inputs.registration_number = input_registration_number.value
    }

    if(input_remarks.value){
      inputs.remarks =input_remarks.value
    }

    if(mv_file_record.value && mv_file_record.value.stradcom && mv_file_record.value.stradcom.selected){
      inputs.stradcom_mv_file_record_id = mv_file_record.value.stradcom.id
      if(mv_file_record.value.stradcom.current_owner_name){
        inputs.stradcom_mv_file_record_input_name = mv_file_record.value.stradcom.current_owner_name
      }
      if(mv_file_record.value.stradcom.incomplete_address){
        inputs.stradcom_mv_file_record_input_incomplete_address = mv_file_record.value.stradcom.incomplete_address
      }
      if(mv_file_record.value.stradcom.city_id){
        inputs.stradcom_mv_file_record_selected_city_id = mv_file_record.value.stradcom.city_id
      }
    }

    if(mv_file_record.value && mv_file_record.value.dermalog && mv_file_record.value.dermalog.selected){
      inputs.dermalog_mv_file_record_id = mv_file_record.value.dermalog.id
      if(mv_file_record.value.dermalog.current_owner_name){
        inputs.dermalog_mv_file_record_input_name = mv_file_record.value.dermalog.current_owner_name
      }
      if(mv_file_record.value.dermalog.incomplete_address){
        inputs.dermalog_mv_file_record_input_incomplete_address = mv_file_record.value.dermalog.incomplete_address
      }
      if(mv_file_record.value.dermalog.city_id){
        inputs.dermalog_mv_file_record_selected_city_id = mv_file_record.value.dermalog.city_id
      }
    }

    await axios.post(`/traffic_record_component/save_or_reject/reject/${traffic_record.value.id}`,inputs,{
      headers: authHeader()
    });
  
    window.location.reload();
    
  }catch(error){
    const { message } = error.response.data;

    const confirm = await Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    })
    if (confirm.isConfirmed) {
      window.location.reload();
      return;
    }
    // return Swal.fire({
    //   icon: 'error',
    //   title: 'Oops...',
    //   text: message,
    // })
  }
  
}

const loading = computed(() => store.state.globals.loading);
</script>

<template>
  <div class="col-12 mb-1">
    <b-overlay :show="loading">
    <div class="card">
      <div class="card-body overflow-auto">
        <div class="row justify-content-md-center">
          <div class="col-12 col-md-12">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <v-select
                  @change="selectRejectReason"
                  :options="reject_reason_list"
                  placeholder="Select Reject Reason" 
                  :get-option-label="(option) => {
                    return `${option.name}`
                  }" 
                  :value="reject_reason_list"
                  :reduce="reject_reason_list => reject_reason_list.id" 
                  append-to-body
                  v-model="selected_reject_reason"
                />
                <!-- <select @change="selectRejectReason" class="form-select" v-model="selected_reject_reason">
                  <option :value="null">
                    Select Reject Reason
                  </option>
                  <template v-for="option in reject_reason_list" :key="option.id" >
                    <option :value="option.id">
                      {{ option.name }}
                    </option>
                  </template>
                </select> -->
                <input v-if="selected_reject_reason && selected_reject_reason == 7" v-model="other_reject_reason" type="text" class="form-control mt-1" placeholder="Enter Other Reason">
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6 mt-md-0 mt-2">
                <div class="row">
                  <div class="col-6">
                    <button @click.prevent="reject" type="button" class="mr-2 w-100 btn btn-danger">Reject</button>
                  </div>
                  <div class="col-6">
                    <button 
                      type="submit" 
                      :disabled="!mv_file_record.dermalog && !mv_file_record.stradcom"
                      class="btn w-100  btn-success" 
                      v-text="([1]).includes(props.phase_id) ? 'Save' : 'Approve'" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </b-overlay>
  </div>
</template>
